import { X } from '@music-vine/cadence/icons';
import { UBLogo } from '@/components/Logo';
import { Button } from '@music-vine/cadence/ui';
interface SidebarLogoHeaderProps {
  onClose: () => void;
}

/**
 * Logo + close bar for the upsell sidebars. Shared so the plan-choice modals
 * can't drift apart again — UpgradeChoice shipped without one at all, and its
 * only way out was the backdrop (DEV-6625).
 */
export const SidebarLogoHeader = ({
  onClose
}: SidebarLogoHeaderProps) => <div className="flex shrink-0 items-center justify-between border-gray-150 border-t-0 border-r-0 border-b border-l-0 border-solid p-6 py-4 dark:border-gray-800" data-sentry-component="SidebarLogoHeader" data-sentry-source-file="SidebarLogoHeader.tsx">
    <UBLogo className="h-9 w-auto" data-sentry-element="UBLogo" data-sentry-source-file="SidebarLogoHeader.tsx" />
    <Button className="rounded-full" onClick={onClose} size="icon" variant="transparent" data-sentry-element="Button" data-sentry-source-file="SidebarLogoHeader.tsx">
      <X className="h-5 w-5" data-sentry-element="X" data-sentry-source-file="SidebarLogoHeader.tsx" />
      <span className="sr-only">Close</span>
    </Button>
  </div>;